import { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import LayerMap from "./Components/LayerMap";
import { FullscreenControl } from "react-leaflet-fullscreen";
import 'leaflet/dist/leaflet.css';
import MarkerComponent from "./Components/Marker";
import sharedService from "../../../Services/SharedService";
import { ONE_DAY, StartOf } from "../../../Utils/time";

const noteIcon = (color = "black", size = 20) => {
    return <>
        <svg xmlns="http://www.w3.org/2000/svg" fill={color} version="1.1" id="Capa_1" width={size + "px"} height={size + "px"} viewBox="0 0 27.37 27.37">
            <g>
                <g>
                    <polygon points="8.332,27.37 19.037,27.37 13.684,11.245   " />
                    <circle cx="13.684" cy="8.104" r="2.141" />
                    <path d="M9.522,12.267c0.105,0.104,0.242,0.157,0.379,0.157c0.137,0,0.274-0.052,0.378-0.157c0.209-0.208,0.209-0.547,0-0.756    c-1.877-1.877-1.877-4.934,0-6.811c0.209-0.209,0.209-0.548,0-0.757c-0.208-0.209-0.547-0.209-0.757,0    C7.227,6.236,7.227,9.972,9.522,12.267z" />
                    <path d="M17.09,12.267c0.104,0.104,0.241,0.157,0.378,0.157s0.274-0.052,0.379-0.157c2.295-2.295,2.295-6.029,0-8.324    c-0.209-0.209-0.548-0.209-0.757,0s-0.209,0.547,0,0.757c1.877,1.877,1.877,4.934,0,6.811    C16.881,11.719,16.881,12.058,17.09,12.267z" />
                    <path d="M8.386,13.402c-2.921-2.921-2.921-7.675,0-10.598c0.209-0.209,0.209-0.547,0-0.756c-0.209-0.209-0.548-0.209-0.757,0    c-3.337,3.338-3.337,8.772,0,12.11c0.104,0.105,0.242,0.157,0.378,0.157c0.136,0,0.274-0.052,0.378-0.157    C8.595,13.95,8.595,13.611,8.386,13.402z" />
                    <path d="M19.74,2.048c-0.208-0.209-0.549-0.209-0.758,0c-0.209,0.209-0.209,0.547,0,0.756c2.922,2.922,2.922,7.676,0,10.598    c-0.209,0.209-0.209,0.547,0,0.756c0.104,0.105,0.241,0.157,0.38,0.157c0.137,0,0.273-0.052,0.378-0.157    C23.077,10.82,23.077,5.388,19.74,2.048z" />
                    <path d="M3.518,8.104c0-2.718,1.057-5.271,2.976-7.191c0.209-0.209,0.209-0.548,0-0.757s-0.548-0.209-0.757,0    c-4.381,4.382-4.381,11.513,0,15.895c0.105,0.104,0.242,0.156,0.379,0.156c0.137,0,0.274-0.052,0.378-0.156    c0.209-0.209,0.209-0.548,0-0.758C4.575,13.375,3.518,10.821,3.518,8.104z" />
                    <path d="M21.631,0.157c-0.208-0.209-0.547-0.209-0.756,0s-0.209,0.547,0,0.757c1.919,1.919,2.976,4.473,2.976,7.191    c0,2.717-1.057,5.271-2.976,7.189c-0.209,0.209-0.209,0.549,0,0.758c0.104,0.104,0.242,0.156,0.378,0.156s0.273-0.052,0.378-0.156    C26.014,11.669,26.014,4.539,21.631,0.157z" />
                </g>
            </g>
        </svg>
    </>
}


const MapComponent = ({ boxs }) => {
    const [boxId, setBoxId] = useState("")
    const [showMenu, setShowMenu] = useState(false)
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])

    const handleShowBoxsRef = useRef();
    const mapRef = useRef(null);

    handleShowBoxsRef.current = () => {
        setShowMenu(prev => !prev);
    };

    const MyMap = () => {
        const map = useMap();
        mapRef.current = map;
        return null;
    }

    const handleSelectBox = (id) => {
        setBoxId(id)
        const box = boxs.find(b => b.id === id)
        if (!box || !box?.location?.lat || !box?.location?.lng) return;
        const map = mapRef.current;
        if (map) {
            map.flyTo([box.location.lat, box.location.lng], 18); // Zoom tùy chỉnh nếu cần
        }
    };

    const BoxsComponent = ({ boxs }) => <div className="absolute z-[999999] ml-[50px] mt-[12.5px] bg-white min-w-[150px] rounded-[3px] ">
        <ul>
            {boxs && boxs.length > 0 && boxs.map(b => <li onClick={() => handleSelectBox(b.id)} key={b.id} className="px-3 py-1 text-center cursor-pointer hover:bg-slate-300 text-sm">{b.name}</li>)}
        </ul>
    </div>

    useEffect(() => {
        sharedService.listRecordBoxGroupByTime({ start: StartOf.Day(Date.now() - ONE_DAY), end: Date.now() }).then(res => {
            const result = res.data
            setData([...result])
        }).catch(e => console.log(e))
    }, [])

    useEffect(() => {
        const X = document.getElementsByClassName("leaflet-control-zoom-fullscreen")
        if (X && X.length > 0 && !X[0].innerHTML) {
            X[0].innerHTML = "[ ]"
        }
    })

    const [center, setCenter] = useState()

    useEffect(() => {
        const id = localStorage.getItem("group_id")
        sharedService.getBoxGroup(id).then(res => {
            const loca = res.data.center
            setCenter({ ...loca })
            const map = mapRef.current;
            if (map) map.flyTo([loca.lat, loca.lng], 16)
        }).catch(e => console.log(e))
    }, [])


    return <>
        {showMenu && <BoxsComponent boxs={boxs || []} />}
        {center && <MapContainer
            center={center}
            zoom={16}
            // maxZoom={19}
            className="Map-Container2"
        >
            <div className="absolute p-[10px] bg-[#00000063] bottom-2 right-2 text-white z-[400] text-sm">
                <div className="flex items-baseline">{noteIcon("dodgerblue", 25)}: Bình thường</div>
                <div className="flex items-baseline">{noteIcon("red", 25)}: Vượt ngưỡng</div>
                <div className="flex items-baseline">{noteIcon("lightgray", 25)}: Mất kết nối</div>
            </div>
            <LayerMap className="pt-10" layers="gg" />
            <MyMap />
            <TileLayer url="https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}" />
            <MarkerComponent boxs={boxs} boxId={boxId} loading={loading} data={data} />
            <FullscreenControl />
        </MapContainer>}
    </>
}

export default MapComponent